export class EligibilityBenefits {
  public deductible: number
  public coinsurance: number
  public copayment: number
  public outOfPocketMax: number
  public copaymentAmbiguous?: boolean
  public coinsuranceAmbiguous?: boolean
}
